export default {
  id: '8cce99defd',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== 'undefined' && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else
            return val;
        } else
          return '';
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '\r\n    <div class="page">\r\n      <div class="navbar paymentPage no-shadow">\r\n        <div class="navbar-bg"></div>\r\n        <div class="navbar-inner">\r\n          <div class="left">\r\n            <a href="#" class="link back">\r\n              <i class="icon f7-icons text-color-blue">chevron_left</i>\r\n            </a>\r\n          </div>\r\n          <div class="title text-color-blue txn-title">Transaction History</div>\r\n          <div class="title-large">\r\n            <div class="title-large-text text-color-blue txn-title">Transaction History</div>\r\n          </div>\r\n          \r\n          <div class="right">\r\n            \r\n          </div>\r\n        </div>\r\n      </div>\r\n    <div class="page-content">\r\n      <div class="block-container txn-history">\r\n        <div class="list media-list no-chevron list-recent-txn no-hairlines">\r\n          <ul>\r\n            \r\n          </ul>\r\n        </div>  \r\n      </div>\r\n    </div>\r\n';
      return r;
    }(this);
  },
  styleScoped: false
};